
export interface VoidFilters {
  numeroDocumento: string;
  dniRuc: string;
}

export interface SalesDocument {
  id: string;
  numero: string;
  fechaEmision: string;
  cliente: {
    nombre: string;
    documento: string;
  };
  total: number;
  estado: 'EMITIDO' | 'ANULADO';
  comprobante: {
    tipo: 'BOLETA' | 'FACTURA';
    serie: string;
    numero: string;
  };
}

class SalesVoidService {
  private baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

  private async apiCall<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const token = localStorage.getItem('accessToken');

    // Get locationId from localStorage
    const userData = localStorage.getItem('macartur:user');
    let locationId = null;
    if (userData) {
      try {
        const user = JSON.parse(userData);
        locationId = user.locationId;
      } catch (e) {
        console.warn('Could not parse user data from localStorage');
      }
    }

    const response = await fetch(`${this.baseURL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Location-ID': locationId,
        ...options.headers,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Error de red' }));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async searchDocuments(filters: VoidFilters): Promise<SalesDocument[]> {
    const params = new URLSearchParams();

    if (filters.numeroDocumento.trim()) {
      params.append('numeroDocumento', filters.numeroDocumento.trim());
    }

    if (filters.dniRuc.trim()) {
      params.append('dniRuc', filters.dniRuc.trim());
    }

    const response = await this.apiCall<{
      success: boolean;
      data: SalesDocument[];
    }>(`/sales/documents/search?${params.toString()}`, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error('Error al buscar documentos');
    }

    return response.data;
  }

  async voidDocument(documentId: string): Promise<{
    success: boolean;
    message: string;
    data: {
      id: string;
      numero: string;
      estado: string;
      fechaAnulacion: string;
    };
  }> {
    const response = await this.apiCall<{
      success: boolean;
      message: string;
      data: {
        id: string;
        numero: string;
        estado: string;
        fechaAnulacion: string;
      };
    }>(`/sales/documents/${documentId}/void`, {
      method: 'PUT',
    });

    if (!response.success) {
      throw new Error('Error al anular documento');
    }

    return response;
  }
}

export const salesVoidService = new SalesVoidService();
